import _ from "lodash";
import { userHasRight } from "../../../framework";
import { Component, ComponentOptions, RightLockable } from "../../components/components/component";
import { Container, PaneIconLink } from "../../components/components/index";
import { TemplateComponent } from "../../components/components/templateComponent";
import K_InsertTabGroup from "../templates/K_InsertTabGroup";
import { InsertTab } from "./insertTab";

export interface InsertTabGroupOptions extends ComponentOptions {
    components: InsertTab[];
    insertLabel?: string;
    tabContainers?: Container[];
    bsc?: string;
    ScreenEntityType?: string;
    requiredRight?: string;
}

export class InsertTabGroup extends TemplateComponent {

    options: InsertTabGroupOptions & RightLockable;
    content: {
        components: InsertTab[];
        tabContainers: Component[];
    };

    constructor(options: InsertTabGroupOptions & RightLockable) {
        var components = options.components;
        options.components = [];
        options.tabContainers = [];

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = options.rightLocked;
                options.containerClasses += " disabled right-locked";
            }
        }

        _.forEach(components, (insertTab, index) => {
            var tabComponents = insertTab.components;

            insertTab.options.tabContainerId = insertTab.options.tabContainerId || "{0}_Tab{1}_TabContainer".format(insertTab.options.id, index);
            insertTab.options.insertButtonId = insertTab.options.insertButtonId || "{0}_Tab{1}_Insert".format(insertTab.options.id, index);
            insertTab.options.cancelButtonId = insertTab.options.cancelButtonId || "{0}_Tab{1}_Cancel".format(insertTab.options.id, index);

            delete insertTab.components;

            options.components.push(insertTab);

            var acceptCancelContainer = new Container({
                classes: "accept-cancel-container",
                components: []
            });

            acceptCancelContainer.content.components.push(new PaneIconLink({
                id: insertTab.options.insertButtonId,
                iconClass: "check",
                toolTip: insertTab.options.insertToolTip
            }));

            acceptCancelContainer.content.components.push(new PaneIconLink({
                id: insertTab.options.cancelButtonId,
                iconClass: "cancel",
                toolTip: insertTab.options.cancelToolTip
            }));

            tabComponents.push(acceptCancelContainer);

            options.tabContainers.push(new Container({
                id: insertTab.options.tabContainerId,
                components: tabComponents,
                screenEntityType: insertTab.options.screenEntityType
            }));
        });

        super(K_InsertTabGroup, options);

        this.content = {
            components: options.components || [],
            tabContainers: options.tabContainers || []
        };
    }

    preRender() {
        this.options.insertLabel = this.options.insertLabel || "Insert";

        _.forEach(this.content.components, insertTab => {
            insertTab.options.absoluteTabGroupContainerId = "{0}_Container".format(this.options.id);
        });
    }

    tabs() {
        var me = this;

        var tabElements = $("#" + me.id + " > .insert-object-group-contents > .insert-object-button");

        return $.map(tabElements, function (tabElement) { return $(tabElement).data("me"); });
    }

}
